// extracted by mini-css-extract-plugin
export default {"container":"WagonsMapFilter_container__wWy34"};